module.exports = __webpack_public_path__ + "font/icons_11052020.ttf";